import React from 'react';
import { Heading, Paragraph } from 'elmo-elements';
import { AppBox } from '../style';
import { ApplicationProps } from '../type';
import { getAppRedirectUrl } from '../../../lib/helpers';
import { AppsNotAuthSupported } from '../../../lib/const/constants';

const IsNotAuthSupportedApp = (appName: string) =>
  AppsNotAuthSupported.find((app) => app === appName) ? true : false;

function Application({
  appName,
  appToken,
  appUrl,
  appLogo,
  appDesc,
}: ApplicationProps) {
  // moved tolowercase fn inline below because of prettier eslint conflict
  // try not to spend more time on fixing this
  const cypressId = appName.split(' ').join('-');

  const onClickHandler = () => {
    if (IsNotAuthSupportedApp(appName)) {
      window.location.href = appUrl;
    } else {
      window.location.href = getAppRedirectUrl(appUrl, appToken);
    }
  };

  return (
    <AppBox id={cypressId.toLowerCase()} onClick={onClickHandler}>
      <img width={110} src={appLogo} alt="logo" />
      <Heading type="title" size="xs" align="left">
        {appName}
      </Heading>
      <Paragraph>{appDesc}</Paragraph>
    </AppBox>
  );
}

export default Application;
